import React from 'react';
import Button from '@mui/material/Button';
const styles = require('../styles.pcss');

interface DeleteFlagSectionProps {
  showDelete: boolean;
  deleteFlag: boolean;
  name: string;
  onClickDeleteFlag: () => void;
  onClickCancelDeleteFlag: () => void;
  onClickConfirmDeleteFlag: () => void;
}

const DeleteFlagSection: React.FC<DeleteFlagSectionProps> = ({
  showDelete,
  deleteFlag,
  name,
  onClickDeleteFlag,
  onClickCancelDeleteFlag,
  onClickConfirmDeleteFlag,
}) => {
  if (!showDelete) return null;
  if (!deleteFlag) {
    return (
      <div className={styles.deleteButtonContainer}>
        <Button size="small" className={styles.buttonDeleteProfile} variant="contained" onClick={onClickDeleteFlag}>
          Delete Feature Flag
        </Button>
      </div>
    );
  }
  return (
    <div className={styles.deleteFlagContainer}>
      <div className={styles.deleteFlagTextContainer}>
        <div className={styles.deleteFlagText}>Delete Feature Flag</div>
        <div className={styles.deleteFlagDescription}>Please confirm you want to delete {name} flag.</div>
      </div>
      <div className={styles.deleteButtonContainer}>
        <Button
          size="small"
          className={`${styles.buttonDeleteProfile} ${styles.cancel}`}
          variant="contained"
          onClick={onClickCancelDeleteFlag}
        >
          Cancel
        </Button>
        <Button size="small" className={`${styles.buttonDeleteProfile} ${styles.delete}`} variant="contained" onClick={onClickConfirmDeleteFlag}>
          Delete
        </Button>
      </div>
    </div>
  );
};

export default DeleteFlagSection;
